module.exports = __webpack_public_path__ + "img/Group 8910.67ccb7ae.svg";